import request from '../utils/request';

/**
 * 签字审核(审核通过/不通过)
 * @param signReview 签字审核对象: {id, coachId, signUrl, state}
 *                   state: 1=审核通过, 2=审核不通过
 */
export const passSignReview = (signReview) => {
    return request({
        url: '/sys/signReview/passSignReview',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(signReview),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
